import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import invariant from "tiny-invariant";
import {
  Button,
  FormControl,
  Box,
  Modal,
  Paper,
  useTheme,
  Typography,
  TextField,
} from "@mui/material";
import { TreeContext } from "../tree-context";
import useStyles from "./styles";
import api from "../../../../../services/api";
import { useNotification } from "../../../../notificationProvider";

export function NewItemModal({
  onClose,
  parentId,
  open,
  type = "PAI",
  position,
  status = 1,
}: {
  onClose: () => void;
  parentId?: string;
  open: boolean;
  type?: "PAI" | "FILHO";
  position?: string;
  status?: number;
}) {
  const { dispatch, getChildrenOfItem, getMoveTargets, getPathToItem } =
    useContext(TreeContext);
  const [title, setTitle] = useState("");
  const [path, setPath] = useState("");
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const notify = useNotification();
  useEffect(() => {
    setTitle("");
    setPath("");
  }, [open]);
  // const options = useMemo(() => {
  //   const targets = getMoveTargets({ itemId });
  //   const targetOptions = targets.map((item) => ({
  //     label: `Item ${item.title}`,
  //     value: item.id,
  //   }));
  //   return [{ label: "No parent", value: "" }, ...targetOptions];
  // }, [getMoveTargets, itemId]);

  // const defaultParent = useMemo(() => {
  //   const path = getPathToItem(itemId);
  //   const parentId = path[path.length - 1] ?? "";
  //   const option = options.find((option) => option.value === parentId);
  //   invariant(option);
  //   return option.value;
  // }, [getPathToItem, itemId, options]);

  // const [parentId, setParentId] = useState(defaultParent);
  // const positionOptions = useMemo(() => {
  //   const targets = getChildrenOfItem(parentId).filter(
  //     (item) => item.id !== itemId
  //   );
  //   return Array.from({ length: targets.length + 1 }, (_, index) => ({
  //     label: String(index + 1),
  //     value: index + 1,
  //   }));
  // }, [getChildrenOfItem, itemId, parentId]);

  // const [position, setPosition] = useState(1);

  // useEffect(() => {
  //   setPosition(1);
  // }, [parentId, positionOptions.length]);
  async function handlePostPageApi(
    title: string,
    path: string,
    type: "PAI" | "FILHO" = "PAI",
    status?: number,
  ): Promise<any | null | undefined> {
    try {
      setLoading(true);
      // console.log("handlePostPageApi", id, filters, title, parentId, position);
      const response = await api.post(
        "/pages/create",
        {
          title,
          type,
          parentId,
          status,
          path: type === "FILHO" ? path : null,
        },
        // { signal }
      );
      if (response.status === 200) {
        notify(null, "Página criada com sucesso", "success");
        return response.data;
      }
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
    return null;
  }

  const onSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      // console.log("onSubmit", parentId, title, position);
      const data = await handlePostPageApi(title, path, type, status);
      if (!data) {
        // notify(null, "Erro ao criar item", "error");
        return;
      }

      if (parentId)
        dispatch({
          type: "create-child",
          itemId: data.id,
          parentId,
          newItem: {
            id: data.id,
            title: data.title,
            path: data.path,
            type: data.type,
            status: data.status,
            position: data.position,
            children: [],
          },
        });
      else
        dispatch({
          type: "create",
          itemId: data.id,
          newItem: {
            id: data.id,
            title: data.title,
            path: data.path,
            type: data.type,
            status: data.status,
            position: data.position,
            children: [],
          },
        });
      onClose();
    },
    [dispatch, parentId, onClose, title, path],
  );

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // Simula o clique no botão ao pressionar Enter
      buttonRef.current?.click();
    }
  };
  return (
    <Modal open={open} closeAfterTransition onClose={onClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        {/* <form onSubmit={onSubmit}> */}
        <Box sx={styles.boxHeader}>
          <Typography variant="h6">
            {"Nov" + (type === "PAI" ? "o Item" : "a Página")}
          </Typography>
        </Box>
        <Box sx={styles.boxContent}>
          {/* <Box display="flex" flexDirection="column" gap={2} mt={1}> */}
          {/* <FormControl fullWidth required> */}
          <TextField
            label="Título"
            variant="filled"
            name="title"
            required
            autoFocus
            onKeyDown={handleKeyDown}
            value={title}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setTitle(e.target.value)
            }
            // sx={styles.textField}
          />
          {type === "FILHO" && (
            <TextField
              label="Path"
              variant="filled"
              name="path"
              onKeyDown={handleKeyDown}
              required
              autoFocus
              value={path}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                let value = e.target.value;
                if (!value.startsWith("/")) {
                  value = "/" + value.replace(/^\/+/, "");
                }
                if (value === "") {
                  value = "/";
                }
                setPath(value);
              }}
              // sx={styles.textField}
            />
          )}
          {/* </FormControl> */}
          {/* </Box> */}
        </Box>
        <Box sx={styles.boxActions}>
          <Button onClick={onClose} variant="outlined" disabled={loading}>
            Cancelar
          </Button>
          <Button
            ref={buttonRef}
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={onSubmit}
          >
            Adicionar
          </Button>
        </Box>
        {/* </form> */}
      </Paper>
    </Modal>
  );
}
